export const HubspotSignupForm = {
  starter: { guid: '22860e11-25bf-4b81-aa71-e7582e27f039', pageName: 'Starter Plan Signup' },
  trial: { guid: '24b2cb64-7486-4bc8-8751-6c876c34b191', pageName: 'Trial Signup' },
} as const

export type HubspotSignupFormType = (typeof HubspotSignupForm)[keyof typeof HubspotSignupForm]

export const HUBSPOT_VISITOR_ID_STORAGE_KEY = 'hubspot-visitor-id'

// The website tags its links with __hstc = <domain hash>.<visitor ID>.<first visit>.<last visit>.<this visit>.<session count>
export const getHubspotVisitorId = (hstc: string) => {
  const [, visitorId = ''] = hstc.split('.')
  return /^[0-9a-f]{32}$/.test(visitorId) ? visitorId : undefined
}
